// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
.container-smart-component {
  padding-block-end: 0;
}

.icon-main {
  width: var(--size-icon-main);
  height: var(--size-icon-main);
  flex-shrink: 0;
  background-color: #017BEC;
  color: white;
  font-size: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .icon-main {
  font-size: 45px;
}
.supervision-view .title {
  font-size: 15px;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}

ion-button {
  margin-block-start: 2px;
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  width: 44px;
  height: 44px;
  --background: white;
  --box-shadow: 0;
  --ripple-color: #017BEC;
  color: #017BEC;
  --transition: transform .2s ease-out;
}
ion-button ion-icon {
  font-size: 30px;
}
ion-button.ion-activated {
  transform: scale(1.2);
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

.container-blind-command {
  min-height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2 - var(--size-icon-main));
}
.container-blind-command > * + * {
  margin-block-start: 30px;
}

.container-blind-button {
  display: flex;
  justify-content: center;
  gap: 40px;
}
.container-blind-button > div {
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  font-size: 12px;
  align-items: center;
  font-weight: 700;
}

.container-slat-position {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.title-label {
  text-transform: uppercase;
  font-size: 14px;
  color: #8b8b8b;
  font-weight: 700;
  align-self: center;
}

.toggle-button {
  color: var(--ion-color-medium-shade);
  display: block;
  font-size: 24px;
  cursor: pointer;
  margin-inline: auto;
  margin-block-start: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-blind/widget-blind.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAtBA;EAGE,oBAAA;AAsBF;;AAnBA;ECsDI,4BAAA;EACA,6BAAA;EACA,cAAA;EDtDF,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAwBF;;AArBA;ECiDI,eAAA;EACA,gBAAA;ADxBJ;;AArBE;EACE,eAAA;AAwBJ;AArBE;EACE,eAAA;AAuBJ;;AAnBA;ECJI,aAAA;EACA,mBAAA;EACA,SAAA;AD2BJ;ACzBI;EACI,2BAAA;EACA,iBAAA;AD2BR;ACxBI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;AD0BR;ACxBQ;EACI,gBAAA;AD0BZ;ACtBI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADwBR;;AAvCA;EACE,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,oCAAA;AA0CF;AAxCE;EACE,eAAA;AA0CJ;AAvCE;EACE,qBAAA;AAyCJ;;AArCA;ECFI,kFAAA;EACA,WAAA;AD2CJ;;AAtCA;EACE,8GAAA;AAyCF;AAvCE;EACE,wBAAA;AAyCJ;;AArCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAwCF;AAtCE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAwCJ;;AApCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAuCF;;AApCA;EACE,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAuCF;;AApCA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kCAAA;AAuCF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n  @include external-apparance;\n\n  padding-block-end: 0;\n}\n\n.icon-main {\n  @include icon-main;\n  background-color: #017BEC;\n  color: white;\n  font-size: 35px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  @include title-main;\n}\n\n.supervision-view {\n  .icon-main {\n    font-size: 45px;\n  }\n\n  .title {\n    font-size: 15px;\n  }\n}\n\n.icon-and-text {\n  @include icon-and-text;\n}\n\nion-button {\n  margin-block-start: 2px;\n  --border-radius: 50%;\n  --padding-start: 0;\n  --padding-end: 0;\n  width: 44px;\n  height: 44px;\n  --background: white;\n  --box-shadow: 0;\n  --ripple-color: #017BEC;\n  color: #017BEC;\n  --transition: transform .2s ease-out;\n\n  ion-icon {\n    font-size: 30px;\n  }\n\n  &.ion-activated {\n    transform: scale(1.2);\n  }\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\n.container-blind-command {\n  min-height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2) - var(--size-icon-main));\n\n  &>*+* {\n    margin-block-start: 30px;\n  }\n}\n\n.container-blind-button {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n\n  &>div {\n    display: flex;\n    flex-direction: column;\n    text-transform: uppercase;\n    font-size: 12px;\n    align-items: center;\n    font-weight: 700;\n  }\n}\n\n.container-slat-position {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.title-label {\n  text-transform: uppercase;\n  font-size: 14px;\n  color: #8b8b8b;\n  font-weight: 700;\n  align-self: center;\n}\n\n.toggle-button {\n  color: var(--ion-color-medium-shade);\n  display: block;\n  font-size: 24px;\n  cursor: pointer;\n  margin-inline: auto;\n  margin-block-start: 5px !important;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
